import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfigurationService } from "../../../../core/services/configuration.service";
import { UserType } from "../../../../core/models/user-type.model";
import { ContentObserver } from '@angular/cdk/observers';
import { ActivatedRoute } from "@angular/router";
import { USER_TYPES } from "../../../../core/shared/constants";
import { BaseComponent } from "../../../../core/shared/base.component";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { UsersService } from '../../../../core/services/users.service';
import { LoaderService } from '../../../../core/shared/services/loader.service';


@Component({
  selector: 'app-account-management',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './account-management.component.html',
  styleUrl: './account-management.component.scss'
})
export class AccountManagementComponent extends BaseComponent implements OnInit {


  usersBase: any[] = [];
  users: any[] = [];
  totalTodosUsuarios: number = 0; // Total de usuarios
  loading = false;

  userTypesEnum = USER_TYPES;

  userTypeId = null;
  pageTitle = "";

  userTypes: any[] = []; // Lista de tipos de usuarios

  showModalForm = false; // Controla la visibilidad del modal
  editMode: boolean = false; // Indica si estamos en modo edición
  usuarioFormGroup!: FormGroup;

  activeTab: any = 'all'; // Tab activo por defecto
  searchTerm: any;
  selectedUserId: string = ''; // ID del usuario seleccionado para edición

  source: string = ''; // Fuente de los usuarios

  private userService = inject(UsersService);
  private configService = inject(ConfigurationService);
  private loader = inject(LoaderService);
  private route = inject(ActivatedRoute);
  private spinner = inject(NgxSpinnerService);
  private formBuilder = inject(FormBuilder); // FormBuilder para crear formularios reactivos


  constructor() {
    super();
  }

  ngOnInit(): void {

    this.route.data.subscribe(data => {

      this.pageTitle = data['pageTitle'];

      this.loadUsers(); // sin paginación
      this.loadUsersByType(); // Cargar tipos de usuarios     

    });

    this.crearFormulario();

  }

  crearFormulario(): void {
    this.usuarioFormGroup = this.formBuilder.group({
      NOMBRE: ['', Validators.required],
      APELLIDO: ['', Validators.required],
      EMAIL: ['', [Validators.required, Validators.email]],
      CODETELEFONO: ['51'],
      TELEFONO: [''],
      FECHAINGRESO: [new Date().toISOString().substring(0, 10), Validators.required],
      CATEGORIAEXPERTO: ['1', Validators.required], // Tipo de mentor por defecto
    });
  }
  // getter para un fácil acceso a los campos de formulario
  get frmUsuario(): any { return this.usuarioFormGroup.controls; } // get de los controles

  loadUsers() {
    this.loading = true;
    this.loader.show();

    console.log('Cargando usuarios con userTypeId:', this.userTypeId);

    this.userService.find(this.userTypeId, '').subscribe({
      next: (response: any) => {
        this.usersBase = response.data;
        this.usersBase = this.usersBase.map((user: any) => {

          // Agregar propiedad para el ngModel del select
          // user.selectedSubscriptionId = user.type?.suscriptionType?.id?.toString() || '0';
          // user.selectedCoachTypeId = user.type?.coachType?.id || 0;
          // user.selectedExpertCategoryId = user.type?.expertCategory?.id || 0;
          user.selectedUserTypeId = user.type?.id || 0;

          if (user.type?.expertCategory) {
            console.log('user.type?.expertCategory', user.type?.expertCategory);
          }

          return user;
        });

        this.totalTodosUsuarios = this.usersBase.length; // Total de usuarios sin paginación
        this.users = this.usersBase;
        this.loading = false;
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error cargando usuarios:', error);
        this.loading = false;
        this.loader.hide();
      }
    });
  }


  changeUserType(userTypeId: number) {
    this.users = this.usersBase.filter(x => x.type.id == userTypeId);

    // Actualizar el activeTab según el tipo de usuario
    switch (userTypeId) {
      case this.userTypesEnum.Customer.id:
        this.activeTab = 'customers';
        break;
      case this.userTypesEnum.Coach.id:
        this.activeTab = 'coaches';
        break;
      case this.userTypesEnum.Expert.id:
        this.activeTab = 'experts';
        break;
      case this.userTypesEnum.Administrator.id:
        this.activeTab = 'administrators';
        break;
      default:
        this.activeTab = 'all';
    }
  }

  updateUserType(user: any, event: any) {
    const selectedUserType = this.userTypes.find(t => t.id === event.target.value);
    console.log('selectedUserType', selectedUserType);
    if (selectedUserType && user) {


      Swal.fire({
        html: `Va ha actualizar el usuario <strong>${user.name}</strong> a tipo de usuario <strong>${selectedUserType.name}</strong>. ¿Desea continuar ?`,
        title: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();
          this.userService.updateUserType(user._id, Number(event.target.value)).subscribe({
            next: (res) => {
              this.spinner.hide();
              console.log('Tipo de usuario actualizado:', res.data);
              // Actualizar el usuario en la lista
              user.type = res.data.type; // Actualizar el tipo de usuario en el objeto user
              user.selectedUserTypeId = user.type.id; // Actualizar el ID del tipo de usuario seleccionado             

            },
            error: () => {
              this.spinner.hide();
            }
          });
        } else {
          user.selectedUserTypeId = user.type?.id || 0; // Revertir al tipo original si se cancela
        }
      });


    }

  }

  // Cargar tipos de usuarios desde el servicio de configuración
  loadUsersByType() {
    this.configService.getUserTypes().subscribe({
      next: (response: any) => {
        this.userTypes = response.data;
        console.log('Tipos de usuarios cargados:', this.userTypes);
      },
      error: (error) => {
        console.error('Error cargando categorías de expertos:', error);
      }
    });
  }


  changeAll() {
    this.activeTab = 'all';
    this.loadUsers(); // Recargar usuarios para asegurarse de que se muestren todos
    this.searchTerm = ''; // Limpiar el término de búsqueda
  }

  changeNew() {
    this.activeTab = 'new';
    this.searchTerm = ''; // Limpiar el término de búsqueda
    // filtrar usuarios por createdAt
    this.users = this.users.filter(user => {
      const createdAt = new Date(user.createdAt);
      const today = new Date();
      const diffTime = Math.abs(today.getTime() - createdAt.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 1; // Mostrar usuarios creados en los últimos 1 días
    });

  }

  newAccount() {
    this.showModalForm = true; // Mostrar el modal para crear una nueva cuenta
    this.editMode = false; // Desactivar el modo edición
    this.source = 'local'; // Asignar la fuente de la nueva cuenta
    // Implementar la lógica para crear una nueva cuenta
    // Por ejemplo, podrías abrir un formulario para ingresar los datos de la nueva cuenta
    console.log("Crear nueva cuenta");
    this.usuarioFormGroup.patchValue({
      NOMBRE: '',
      APELLIDO: '',
      EMAIL: '',
      TELEFONO: '',
      FECHAINGRESO: new Date().toISOString().substring(0, 10),
    });
    // this.usuarioFormGroup.markAsPristine();
    // this.usuarioFormGroup.markAsUntouched();
  }

  // busqueda usuario
  searchUsers() {
    const term = this.searchTerm.toLowerCase().trim();

    if (!term || term.trim() === '') {
      // Si la búsqueda está vacía, mostrar todos los usuarios
      this.loadUsers();
      return;
    }
    // Filtrar usuarios por nombre
    this.users = this.users.filter(user => {
      const userName = user.name ? user.name.toLowerCase() : '';
      return userName.includes(term);
    }
    );
    console.log('Usuarios filtrados:', this.users);
  }

  closeModalForm() {
    this.showModalForm = false; // Ocultar el modal
  }

  guardarUsuario() {
    if (this.usuarioFormGroup.invalid) {
      console.error("Formulario inválido");
      return;
    }

    // const textCategoriaExperto = this.expertCategories.find(category => category.id === this.frmUsuario.CATEGORIAEXPERTO.value)?.name || 'Sin categoría';

    const usuarioData = {
      name: this.frmUsuario.NOMBRE.value,
      firstName: this.frmUsuario.NOMBRE.value,
      lastName: this.frmUsuario.APELLIDO.value,
      email: this.frmUsuario.EMAIL.value,
      source: this.source,
      phone: this.frmUsuario.TELEFONO.value,
      codePhone: this.frmUsuario.CODETELEFONO.value,
      createdAt: this.frmUsuario.FECHAINGRESO.value,
      type: {
        ...USER_TYPES.Expert, // Asignar el tipo de usuario Expert
        expertCategory: {
          id: this.frmUsuario.CATEGORIAEXPERTO.value === '0' ? null : Number(this.frmUsuario.CATEGORIAEXPERTO.value),
          // name: textCategoriaExperto,
        },
      },
      status: {
        id: 2,
        name: 'Activo',
      }
    };


    // Aquí puedes llamar al servicio para guardar el usuario
    console.log("Datos del usuario a guardar:", usuarioData);

    if (this.editMode) {
      // Si estamos en modo edición, actualizar el usuario existente
      console.log('this.selectedUserId', this.selectedUserId)
      this.userService.updateUser(this.selectedUserId, usuarioData).subscribe({
        next: (response: any) => {
          console.log('Usuario actualizado:', response.data);
          this.loadUsers(); // Recargar la lista de usuarios después de actualizar
          // Cerrar el modal después de actualizar
          this.closeModalForm();
        },
        error: (error) => {
          console.error('Error actualizando usuario:', error);
        }
      });
    }
    else {
      // Si no estamos en modo edición, crear un nuevo usuario
      // Implementa la lógica para guardar el usuario
      this.userService.createUser(usuarioData).subscribe({
        next: (response: any) => {
          console.log('GUARDADO:', response.data);
          this.loadUsers(); // Recargar la lista de usuarios después de guardar
          // Cerrar el modal después de guardar
          this.closeModalForm();
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
    // Cerrar el modal después de guardar
    // this.closeModalForm();
  }

  editarUsuario(usuario: any) {
    this.editMode = true; // Activar el modo edición
    this.showModalForm = true; // Mostrar el modal de edición
    console.log('Editar usuario:', usuario);
    this.selectedUserId = usuario._id; // Guardar el ID del usuario seleccionado
    this.source = usuario.source; // Asignar la fuente del usuario 
    console.log('Fuente del usuario:', this.source);
    this.usuarioFormGroup.patchValue({
      NOMBRE: usuario.name,
      APELLIDO: usuario.lastName,
      EMAIL: usuario.email,
      TELEFONO: usuario.phone,
      CODETELEFONO: usuario.codePhone || '51', // Asignar código de teléfono por defecto si no existe
      FECHAINGRESO: usuario.createdAt ? new Date(usuario.createdAt).toISOString().substring(0, 10) : new Date().toISOString().substring(0, 10),
      // TIPOMENTOR: usuario.type?.coachType?.id ? usuario.type.coachType.id.toString() : '0', // Asignar ID de tipo de mentor o 0 por defecto  
    });
  }

}
